export default "__VITE_PUBLIC_ASSET__b703b625__"